export const getSessionData = (keyName) => {
  switch (keyName) {
    case "user_name":
      return sessionStorage.getItem("user_name");
    case "phone_number":
      return sessionStorage.getItem("phone_number");
    case "user_id":
      return sessionStorage.getItem("user_id");
    case "user_type":
      return sessionStorage.getItem("user_type");
    case "token":
      return sessionStorage.getItem("token");
    default:
      return "Invalid Key Name";
  }
};
